<template>
  <div class="m-base-custom">
    <div class="customer-container">
      <div class="custom-item app-flex-mid-center" v-for="(item, index) in list" :key="index">
        <img :src="require('../../../assets/customer/' + item + '.png')" class="customer-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCustom',
  props: {
    // 是否显示展开全部合作商，fold 为折叠时的效果，open 为展开后的效果
    type: {
      type: String,
      default: 'fold'
    }
  },
  created() {
    if (this.type == 'fold') {
      this.list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16]
    } else {
      this.list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
    }
  },
  data() {
    return {
      list: []
    }
  }
}
</script>
<style lang="scss" scoped>
.m-base-custom {
  .customer-container {
    display: flex;
    flex-wrap: wrap;
    .custom-item {
      width: 106px;
      height: 44px;
      background: #ffffff;
      overflow: hidden;
      box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.08);
      transition: all 0.3s;
      &:not(:nth-child(3n)) {
        margin-right: 8px;
      }
      &:not(:nth-child(-n + 3)) {
        margin-top: 10px;
      }
      //   &:hover {
      //     // transform: scale(1.01);
      //     box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);
      //   }
      .customer-icon {
        width: 106px;
        height: auto;
      }
    }
  }
}
</style>
